import { Outlet } from "react-router";
import { NavbarBrand } from 'react-bootstrap';

const LandingLayout = () => {
    return (
        <>
            <NavbarBrand />
            <Outlet />
        </>
    );
};

export default LandingLayout;